import './assets/styles/App.css';
import 'bootstrap';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './components/Routes';
import ScrollToTop from './components/ScrollToTop';
import Head from './components/Head';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieDisclaimer from './components/CookieDisclaimer';

const App = () => (
  <Router>
    <ScrollToTop>
      <CookieDisclaimer />
      <Head />
      <div className="main-wrapper">
        <Navbar />
        <Routes />
        <Footer />
      </div>
    </ScrollToTop>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js